<template>
  <div id="bpmn-js-modeler">
    <div class="content" id="js-drop-zone" :class="[{'with-diagram': withDiagram}, {'with-error': withError}]">
      <div class="canvas" id="js-canvas"></div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import BpmnModeler from 'bpmn-js/lib/Modeler'

import 'bpmn-js/dist/assets/diagram-js.css'
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css'

export default {
  name: 'Modeler',
  props: {
    newDiagram: {
      type: String,
      required: true
    },
    save: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      container: null,
      modeler: null,
      withDiagram: false,
      withError: false
    }
  },
  methods: {
    createNewDiagram () {
      this.openDiagram(this.newDiagram)
    },
    openDiagram (xml) {
      var self = this
      this.modeler.importXML(xml, function(err) {
        if (err) {
          self.withDiagram = false
          self.withError = true
          console.error(err)
        } else {
          self.withDiagram = true
          self.withError = false
          self.$emit('bpmnModelerLoaded')
        }
      })
    },
    saveDiagram () {
      var self = this
      this.modeler.saveXML({ format: true }, function(err, xml) {
        self.modeler.saveSVG(function(err, svg) {
          self.$emit('diagramSaved', xml, svg)
        })
      })
    }
  },
  mounted () {
    this.container = $('#bpmn-js-modeler #js-drop-zone')
    this.modeler = new BpmnModeler({
      container: '#js-canvas'
    })

    this.createNewDiagram()
  },
  watch: {
    save (save) {
      this.saveDiagram()
    }
  }
}
</script>

<style src="../assets/css/app.scss" lang="scss"></style>

<style>
#bpmn-js-modeler {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// node_modules/vue-bpmn-js-modeler/src/components/Modeler.vue